import { POST } from "../../index";

export const getDriverAnnualApproveList = (param) => POST("/v1/DriverAnnualApprove/getDriverAnnualApproveList", param);
export const getDriverApproveProgressList = (param) => POST("/v1/DriverAnnualApprove/getDriverApproveProgressList", param);
export const submitDriverAudit = (param) => POST("/v1/DriverAnnualApprove/submitDriverAudit", param);
